/* eslint-disable @next/next/no-img-element */
import HeadingServices from '../HeadingServices';
import Paragraf from '../Paragraf';
import CyberModal from '../consultancy/CyberModal';
import { useSelector, useDispatch } from 'react-redux';
import { set_modal } from '../../../redux/actions/appActions'
import PlayIcon from '../../ui/svgs/PlayIcon';

export default function Tscm({ datasTscm, locale}) {
    
    const isModal = useSelector(state => state.app.isModalPos)
    const dispatch = useDispatch();

    const toggleModal = (pos) => {
        dispatch(set_modal(pos))
    }

    return (
        <div onClick={() => {if(isModal)toggleModal(false)}}>
            {locale==="tr" && 
            <CyberModal 
                shown={isModal} 
                close={toggleModal}
                src='https://www.youtube.com/embed/nC9f-qto8Hs'/>
            }
            <HeadingServices lowerTitle={datasTscm.documentTitle}/>
            <div className="container my-3 my-lg-5">
                <div className="row mb-5">
                    <div className="col">
                    
                        <div className="position-relative float-right img-fluid img-small-width pl-md-3 pb-2" >
                                <img
                                    width="100%"
                                    height="100%"
                                    src="/images/cyber/video.png"
                                    alt="technical surveilance countermeasures" 
                                /> 
                                
                                {locale==="tr" && 
                                <button type="button" 
                                    onClick={() => toggleModal(true)}
                                    className="position-absolute top-50pct left-50pct transform3dxy-n50  
                                rounded-circle d-flex align-items-center justify-content-center  
                                play-button-lg pulseAnim pulseAnimAnimated">
                                        <PlayIcon />
                                </button>}
                        </div>
                        <Paragraf parag={datasTscm.pOne} />
                        <Paragraf parag={datasTscm.pTwo} />
                        <Paragraf parag={datasTscm.pThree} />
                    </div>
                </div>
            </div>
        </div>
    )
}
